define(["./monitoringTripStartOverviewModule"], function (module) {
    "use strict";

    return module.controller("monitoringTripStartOverviewController", [
        "$scope",
        function ($scope) {
            $scope.currentDashboard =   {
                dashboardSourceId: ""
            };
        }]);
});